import { ChainEnv } from '@vertex-protocol/client';

export const ARB_CHAIN_ENVS: ChainEnv[] = [
  'arbitrum',
  'arbitrumTestnet',
  'local',
];
export const MANTLE_CHAIN_ENVS: ChainEnv[] = ['mantle', 'mantleTestnet'];
export const SEI_CHAIN_ENVS: ChainEnv[] = ['sei', 'seiTestnet'];
export const BLAST_CHAIN_ENVS: ChainEnv[] = ['blast', 'blastTestnet'];
export const BASE_CHAIN_ENVS: ChainEnv[] = ['base', 'baseTestnet'];
export const SONIC_CHAIN_ENVS: ChainEnv[] = ['sonic', 'sonicTestnet'];
export const ABSTRACT_CHAIN_ENVS: ChainEnv[] = ['abstract', 'abstractTestnet'];
export const BERACHAIN_CHAIN_ENVS: ChainEnv[] = ['bera', 'beraTestnet'];
export const AVAX_CHAIN_ENVS: ChainEnv[] = ['avax', 'avaxTestnet'];
export const INK_CHAIN_ENVS: ChainEnv[] = ['inkMainnet', 'inkTestnet'];
